import React from 'react';
import styled from 'styled-components';
import Icon from '@houzz/ui/icon';
import TwoInwardAngleArrows from '@houzz/icons/TwoInwardAngleArrows';
import TwoOutwardAngleArrows from '@houzz/icons/TwoOutwardAngleArrows';

const StyledSummary = styled.summary`
    display: flex;
    width: 100%;
    align-items: center;
    cursor: pointer;
    font-size: 0.88rem;
    line-height: 1.6;
    font-weight: semibold;
    text-decoration: underline;

    & ~ * {
        margin-top: 0;
    }
`;

export default function Summary({ children }) {
    const elRef = React.useRef(null);
    const [isExpanded, setIsExpanded] = React.useState(false);
    const onDetailsToggle = ({ newState }) => {
        setIsExpanded(newState === 'open');
    };

    React.useEffect(() => {
        const details = elRef.current?.parentNode;
        if (!details) {
            return;
        }

        details.addEventListener('toggle', onDetailsToggle);

        return () => details.removeEventListener('toggle', onDetailsToggle);
    }, []);

    return (
        <StyledSummary ref={elRef}>
            <Icon size="16px" mr="XXS" as={isExpanded ? TwoInwardAngleArrows : TwoOutwardAngleArrows} />
            {children}
        </StyledSummary>
    );
}
